import { jsx as _jsx } from "react/jsx-runtime";
import { ListItemText as MuiListItemText, } from '@mui/material';
import { styled } from '../../utils';
const ListItemTextStyled = styled(MuiListItemText)({
    color: 'inherit',
});
// Important: We can't export directly as styled here because of it would end up as a circular dependency. Not sure why though.
export function ListItemText(props) {
    return _jsx(ListItemTextStyled, { ...props });
}
